import { useCallback, useState } from 'react';
import toast from 'react-hot-toast';
import { openCircleFileInNewTab } from './openCircleFile';

export const useOpenCircleFile = () => {
  const [openingFileId, setOpeningFileId] = useState<string | null>(null);

  const openFile = useCallback(async (fileId: string) => {
    if (!fileId) {
      return;
    }

    setOpeningFileId(fileId);
    try {
      await openCircleFileInNewTab(fileId);
    } catch {
      toast.error('Could not open the file. Please try again.');
    } finally {
      setOpeningFileId(null);
    }
  }, []);

  return { openFile, openingFileId };
};
